/* eslint-disable */
import React, { useState, useEffect } from "react";
import Assistants from "./Assistants";
import AddAssistant from "./AddAssistant";
import { getAssistantsByUser } from "../../actions/assistantActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";

const AssistantList = () => {
  const history = useHistory();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile"));
  const { assistants } = useSelector((state) => state.assistants);
  const isLoading = useSelector((state) => state.product.isLoading);

  useEffect(() => {
    dispatch(
      getAssistantsByUser({ search: user?.result?._id || user.result.googleId })
    );
  }, [location, dispatch]);

  if (!user) {
    history.push("/login");
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (assistants?.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
          margin: "80px",
        }}
      >
        <NoData />
        <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
          No assistants yet. Click the plus icon to add customer
        </p>
      </div>
    );
  }

  return (
    <div>
      <AddAssistant
        open={open}
        setOpen={setOpen}
        currentId={currentId}
        setCurrentId={setCurrentId}
      />
      <Assistants
        open={open}
        setOpen={setOpen}
        currentId={currentId}
        setCurrentId={setCurrentId}
        assistants={assistants}
      />
    </div>
  );
};

export default AssistantList;
